import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const postSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
export const getAuthConfig = () => api.get("/auth/config").then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

export const getProspects = () => api.get("/prospects").then((r) => r.data);
export const getProspect = (id) => api.get(`/prospects/${id}`).then((r) => r.data);
export const createProspect = (data) => api.post("/prospects", data).then((r) => r.data);
export const updateProspect = (id, data) => api.put(`/prospects/${id}`, data).then((r) => r.data);
export const deleteProspect = (id) => api.delete(`/prospects/${id}`).then((r) => r.data);
export const updateStatus = (id, status) =>
  api.patch(`/prospects/${id}/status`, { status }).then((r) => r.data);
export const analyzeProspect = (id) => api.post(`/prospects/${id}/analyze`).then((r) => r.data);
export const importCsv = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/prospects/import", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const getDashboard = () => api.get("/dashboard").then((r) => r.data);

export const startSequence = (id) => api.post(`/prospects/${id}/sequence/start`).then((r) => r.data);
export const completeStep = (id, index, body) =>
  api.post(`/prospects/${id}/sequence/step/${index}/complete`, body).then((r) => r.data);
export const addContactLog = (id, body) =>
  api.post(`/prospects/${id}/contact-log`, body).then((r) => r.data);

export const discover = (body) => api.post("/prospects/discover", body).then((r) => r.data);
export const discoverSave = (prospects) =>
  api.post("/prospects/discover/save", { prospects }).then((r) => r.data);

export const getKpi = (weekOffset = 0) => api.get(`/kpi?week_offset=${weekOffset}`).then((r) => r.data);
export const getTargets = () => api.get("/kpi/targets").then((r) => r.data);
export const setTargets = (body) => api.put("/kpi/targets", body).then((r) => r.data);
export const getKpiReport = (weekOffset = 0) => api.get(`/kpi/report?week_offset=${weekOffset}`).then((r) => r.data);

export const generateMessages = (id) => api.post(`/prospects/${id}/messages`).then((r) => r.data);

export const exportPipelineCsv = () =>
  api.get("/export/pipeline.csv", { responseType: "blob" }).then((r) => r.data);

export const getTeamSettings = () => api.get("/settings/team").then((r) => r.data);
export const getAuthEvents = (limit = 30) => api.get(`/settings/auth-events?limit=${limit}`).then((r) => r.data);
export const setTeamSettings = (body) => api.put("/settings/team", body).then((r) => r.data);

export const getAiSettings = () => api.get("/settings/ai").then((r) => r.data);
export const setAiSettings = (body) => api.put("/settings/ai", body).then((r) => r.data);
export const testAiSettings = (body) => api.post("/settings/ai/test", body).then((r) => r.data);

export const getIgSettings = () => api.get("/settings/instagram").then((r) => r.data);
export const setIgSettings = (body) => api.put("/settings/instagram", body).then((r) => r.data);
export const testIgSettings = () => api.post("/settings/instagram/test").then((r) => r.data);
export const fetchProspectInstagram = (id) => api.post(`/prospects/${id}/instagram/fetch`).then((r) => r.data);
export const fetchAllInstagram = () => api.post("/prospects/instagram/fetch-all").then((r) => r.data);
export const getJob = (id) => api.get(`/jobs/${id}`).then((r) => r.data);
export const refreshIgToken = () => api.post("/settings/instagram/refresh").then((r) => r.data);

export const runEngine = (id) => api.post(`/prospects/${id}/engine`).then((r) => r.data);
export const generateActionPlan = (id) => api.post(`/prospects/${id}/action-plan`).then((r) => r.data);
export const scanWebsite = (id) => api.post(`/prospects/${id}/scan-website`).then((r) => r.data);
export const getPriorityList = (limit = 50) => api.get(`/prospects/priority?limit=${limit}`).then((r) => r.data);
